export enum MessageTypes {
  All = 0,
  Message = 1,
  SchoolGradesInput = 2,
  Reserve = 3
}

export function getMessageTypeName(value: MessageTypes): string {
  switch (value) {
    case MessageTypes.All:
      return 'すべて';
    case MessageTypes.Message:
      return 'メッセージ';
    case MessageTypes.SchoolGradesInput:
      return '成績入力依頼';
    case MessageTypes.Reserve:
      return '予約';
  }
}
